<div class="gridContainer">
	<sim-list icon="fa-users" label="EXAM_SESSION_DIALOG_STEP3_SELECTED_STUDENTS" [counter]="step3Form.value.length">
		<ng-container actions>
			<sim-autocomplete
				[dataType]="FetchDataType.SimUser"
				[excludeIds]="excludeIds()"
				labelToken="{{ T.AUTOCOMPLETE_SEARCH | translate: {item: T.LABEL_STUDENTS | translate} }}"
				(onSelect)="addStudent($event)"
			>
				<mat-icon fontIcon="fa-user-graduate" fontSet="fad" labelPrefix />
			</sim-autocomplete>
		</ng-container>

		@for (student of step3Form.value; track student.id) {
			<sim-user-list-item
				(onDelete)="removeStudent($event)"
				[user]="student"
				[deletable]="true"
				[showOnClickDialog]="false"
				(onSelect)="selectedStudent.set(student)"
				[selected]="selectedStudent()?.id === student.id"
			/>
		}
	</sim-list>

	<mat-divider vertical />

	<sim-user-details [user]="selectedStudent()" [participantType]="ParticipantType.Learner" />
</div>
